import { writable } from "svelte/store";

const loadSettings = () => {
    const stored = localStorage.getItem("settings");
    if (stored) {
        const parsed = JSON.parse(stored);
        return {
            dark_mode: !!parsed.dark_mode,
        };
    } else {
        return {
            dark_mode: false,
        };
    }
};

export const settings = writable(loadSettings());

settings.subscribe((s) => {
    localStorage.setItem("settings", JSON.stringify(s));
});
